var main = (function($) {
  function init() {
  }

  return {
    init: init
  };
}(jQuery));
